var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.tenantSetup.imageUrl)?_c('img',{staticStyle:{"width":"240px"},attrs:{"src":_vm.tenantSetup.imageUrl}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }